import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { DishIngredientsSelectPage } from "../dish-cost/dish-ingredients-select/dish-ingredients-select";
import { DishCreatePricePage } from "../dish-create-price/dish-create-price";
import { DishServices } from "../../services";
import { IngredientsServices } from '../../../ingredients/services';
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';


/**
 * Generated class for the DishCreateFinishPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dish-create-finish',
  templateUrl: 'dish-create-finish.html',
})
export class DishCreateFinishPage {

  dish_uid: string;
  update_state: boolean = false;
  dish_name: string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public dishServices: DishServices,
    public ingredientsServices: IngredientsServices,
    public globals: Globals) {

    this.dish_uid = this.navParams.get('dish_uid');
    this.update_state = this.navParams.get('update');
    this.dish_name = this.navParams.get('dish_name');
  }

  openDishCost() {
    if (this.globals.checkLimitsByLicense('dishes', 'foodcost')) {
      this.dishServices.quick_create_type = false;
      this.navCtrl.push(DishIngredientsSelectPage, {
        dish_uid: this.dish_uid,
        update: this.update_state,
        dish_name: this.dish_name
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }


  openPrice() {
    this.globals.tourLaunchStep(7);
    this.dishServices.quick_create_type = true;
    this.navCtrl.push(DishCreatePricePage, {
      dish_uid: this.dish_uid,
      update: this.update_state,
      dish_name: this.dish_name
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-create-finish/dish-create-finish.ts